import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { IItemSearch, IItemDetail } from "./itemType"

class ItemService {
    async page(searchVo: IItemSearch) {
        const apiUrl = "/zzw-vrm/base/item/findPage";
        return await httpRequest.post<IPage<IItemDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/base/item/findById/${id}`;
        return await httpRequest.get<IItemDetail>(apiUrl);
    }
    async insert(insertVo: IItemDetail) {
        // const apiUrl = "/zzw-vrm/base/item/insert";
        // return await httpRequest.post<string>(apiUrl, insertVo);
        return this.saveItem(insertVo);
    }
    async update(updateVo: IItemDetail) {
        const apiUrl = "/zzw-vrm/base/item/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
        // return this.saveItem(updateVo);
    }
    async saveItem(data: IItemDetail) {
        const apiUrl = "/zzw-vrm/base/item/save";
        return await httpRequest.post<string | boolean>(apiUrl, data);
    }
    //启用禁用
    async disable(params: object) {
        const apiUrl = `/zzw-vrm/base/item/change`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/zzw-vrm/base/item/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: IItemSearch) {
        const appPageUrl = "/zzw-vrm/base/item/export";
        return await httpRequest.postFile(appPageUrl, searchVo);
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/zzw-vrm/base/item/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
}
export const itemService = new ItemService();